export const addTabTypeMigration = tab => {
    tab.isDraggable = true;
    tab.tabType = 'normal';
    return tab;
};
